import {
  DBSCheckPage,
  ShiftsInfoPage,
  Dashboard,
  BookingRequests,
} from 'containers/worker/pages';

import { ROUTE_WORKER_PREFIX as ROUTE_PREFIX } from 'utils/routes';

const workerRoutes = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
  },
  {
    name: 'DBS check',
    path: '/dbs-check',
    component: DBSCheckPage,
  },
  {
    name: 'Shifts info',
    path: '/shifts-info',
    component: ShiftsInfoPage,
  },
  {
    name: 'Booking Requests',
    path: '/booking-requests',
    component: BookingRequests,
  },
];

const Routes = workerRoutes.map((route) => {
  return {
    ...route,
    path: `${ROUTE_PREFIX}${route.path}`,
    public: false,
    confirmedUser: true,
    worker: true,
  };
});

export default Routes;
